import React, {FC} from 'react';

import {Plural, Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Banner, BannerTypesEnum} from '../../../common/banners/banner';
import {BannerAction} from '../../../common/banners/bannerAction';
import {BannerCloseAction} from '../../../common/banners/bannerCloseAction';
import {BannerContent} from '../../../common/banners/bannerContent';
import {BannerContentTitle} from '../../../common/banners/bannerContentTitle';
import {BannerFooterActions} from '../../../common/banners/bannerFooterActions';
import {BannerIcon} from '../../../common/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../common/banners/bannersContext';

/*
 * Props.
 */

interface DiscountEndingBannerProps {
  daysLeftInDiscount: number;
  onDismissClick: Handler;
  onLinkClick: Handler;
}

/*
 * Component.
 */

export const DiscountEndingBanner: FC<DiscountEndingBannerProps> = (props) => {
  const theme = useUserTheme();
  const {daysLeftInDiscount, onDismissClick, onLinkClick} = props;

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.orange.shade40}
      priority={BannerPrioritiesEnum.INFORMATION}
    >
      <BannerCloseAction onClick={onDismissClick} />
      <BannerIcon iconName="warningFilledSmall" />
      <BannerContent>
        <BannerContentTitle>{renderDaysLeftInDiscount(daysLeftInDiscount)}</BannerContentTitle>
        <Trans id="banner-discountending-description">Contact sales to discuss your plan options</Trans>
      </BannerContent>
      <BannerFooterActions>
        <BannerAction onClick={onLinkClick}>
          <Trans id="banner-discountending-action">Contact sales</Trans>
        </BannerAction>
      </BannerFooterActions>
    </Banner>
  );
};

/*
 * Helpers.
 */

function renderDaysLeftInDiscount(daysLeftInDiscount: number) {
  return (
    <Plural
      id="banner-discountending-title-daysleftindiscount"
      value={daysLeftInDiscount}
      one="Your discount ends within 24 hours"
      other="Your discount ends in # days"
    />
  );
}
